<template>
  <div
    class="mb-8 divide-y rounded-md border border-neutral-200 text-neutral-900"
    :data-ab-id="dataAbId"
  >
    <SfAccordionItem
      v-for="(accordion, index) in slides"
      :key="index"
      :model-value="isOpen(index)"
      @update:model-value="toggle(index, $event)"
    >
      <template #summary>
        <div class="flex justify-between p-4 font-medium hover:bg-neutral-100 active:bg-neutral-100">
          <p>{{ accordion.heading }}</p>
          <SfIconChevronLeft :class="['text-neutral-500', { 'rotate-90': isOpen(index), '-rotate-90': !isOpen(index) }]" />
        </div>
      </template>
      <div
        class="p-4 font-light [&_p]:my-4 [&_ul]:ml-6"
        v-html="accordion.content"
      />
    </SfAccordionItem>
  </div>
</template>

<script lang="ts" setup>
import { SfAccordionItem, SfIconChevronLeft } from '@storefront-ui/vue';

defineComponent({ name: 'AccordionComponent' });

interface Props {
  slides?: { heading?: string; content?: string }[];
  dataAbId?: string;
}

withDefaults(defineProps<Props>(), {
  slides: () => ([]),
});

const opened = ref<number | null>(null);

const isOpen = (id: number) => id === opened.value;

const toggle = (id: number, open: boolean) => {
  if (open) {
    opened.value = id;
  }
  else if (isOpen(id)) {
    opened.value = null;
  }
};
</script>
